import { useLocalStorageState } from 'ahooks';
import { useMemo } from 'react';
import { ONE_DAY } from '@/app/constants';

/**
 * 带过期时间的本地存储钩子
 * @param storageKey 存储键名
 * @param expiryTime 过期时间(毫秒)，默认为一天
 * @returns 返回是否过期和设置过期时间的函数
 */
export const useLocalStorageExpired = (storageKey: string, expiryTime: number = ONE_DAY) => {
  const [expire, updateExpire] = useLocalStorageState<string | undefined>(storageKey, {
    defaultValue: undefined,
  });

  const isExpired = useMemo(() => {
    // 是否过期
    return !expire || new Date(expire).toISOString() < new Date().toISOString();
  }, [expire]);

  const setExpiry = () => {
    // 更新过期时间
    updateExpire(new Date(Date.now() + expiryTime).toISOString());
  };

  return {
    isExpired,
    setExpiry,
  };
};
